import { render, staticRenderFns } from "./LinkStepBack.vue?vue&type=template&id=5e8acc20&scoped=true&"
import script from "./LinkStepBack.vue?vue&type=script&lang=js&"
export * from "./LinkStepBack.vue?vue&type=script&lang=js&"
import style0 from "./LinkStepBack.vue?vue&type=style&index=0&id=5e8acc20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8acc20",
  null
  
)

export default component.exports